export const formatLocale = (loc) => {
  if (loc === 'cn') { //兼容产研的写法
    return 'zh-CN';
  } else if (loc === 'en') { //兼容产研的写法
    return 'en-US';
  } else if (/^[a-z]{2,3}($|(\-.*)?$)/.test(loc)) { //标准的locale
    return loc;
  }
  return 'en-US'; //fallback
};



// WEBPACK FOOTER //
// ./src/common/localeUtil.js